import styled, { useTheme } from 'styled-components'
import Button from '@/components/common/buttons/Button'
import { Image } from '@/components/common/images/Image'
import { Typo, TypoVariant } from '@/components/common/typography'
import SeoHeader from '@/components/domains/layouts/header/SeoHeader'
import { InitSocialMetaTag } from '@/constants/initial-social-meta-tag.enum'
import { S3_HOST_URL, S3_ROOT_FOLDER } from '@/constants/legacy/constEnv'
import { SCREEN_SIZES } from '@/constants/legacy/constLayout'
import ROUTES from '@/constants/legacy/constRoutes'
import { useHealthEventTracker } from '@/containers/event-tracker/health.event-tracker'

const healthHomeOneLink = 'https://fitpet.onelink.me/e5Nb/zqpm5hjb'
const communityOneLink = 'https://fitpet.onelink.me/e5Nb/udf16zow'

const getHealthImagePath = (path: string) => `${S3_HOST_URL}/${S3_ROOT_FOLDER}/health/${path}`

const IMAGE_DATA = [
  {
    image: getHealthImagePath('intro-1.jpg'),
    width: 1280,
    height: 9694,
  },
  {
    image: getHealthImagePath('intro-2.jpg'),
    width: 1280,
    height: 500,
  },
  {
    image: getHealthImagePath('intro-3.jpg'),
    width: 1280,
    height: 229,
    link: healthHomeOneLink,
  },
  {
    image: getHealthImagePath('intro-4.jpg'),
    width: 1280,
    height: 229,
    link: communityOneLink,
  },
  {
    image: getHealthImagePath('intro-5.jpg'),
    width: 1280,
    height: 723,
  },
]

const HealthIntro = () => {
  const { color } = useTheme()
  const { trackClickPlayAppDownload } = useHealthEventTracker()
  const handleClickImage = (link?: string) => {
    if (link) {
      window.location.href = link
    }
  }

  const handleClickButton = () => {
    trackClickPlayAppDownload()
    window.location.href = healthHomeOneLink
  }
  return (
    <>
      <SeoHeader
        title={InitSocialMetaTag.Title}
        metaDescription={InitSocialMetaTag.Description}
        imageUrl={InitSocialMetaTag.Image}
        pathname={ROUTES.HEALTH.INTRO}
      />
      <StyledContainer>
        {IMAGE_DATA.map(({ link, image, width, height }) => (
          <ImageContainer hasLink={!!link} key={image} onClick={() => handleClickImage(link)}>
            <Image className="health_image" src={image} alt={image} aspectRatio={`${width / height}`} />
          </ImageContainer>
        ))}

        <StyledFloatingButton>
          <Button.Primary width={'100%'} height={'5rem'} className="download-button" onClick={handleClickButton}>
            <Typo variant={TypoVariant.Body1Bold} color={color.grayWhite}>
              핏펫 앱으로 시작하기
            </Typo>
          </Button.Primary>
        </StyledFloatingButton>
      </StyledContainer>
    </>
  )
}

const StyledContainer = styled.div`
  padding-bottom: calc(env(safe-area-inset-bottom) + 8.2rem);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0;
  .health_image {
    width: 100%;
    vertical-align: top;
    display: inline-block;
  }
`

const StyledFloatingButton = styled.div`
  position: fixed;
  bottom: 61px;
  width: 100%;
  max-width: ${SCREEN_SIZES.md}px;
  padding: 1.6rem;
  background-color: white;

  box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.05);
  button.download-button {
    font-size: 1.6rem;
    font-weight: ${({
      theme: {
        fontWeight: { bold },
      },
    }) => bold};
  }

  p {
    margin-bottom: 3.7rem;
    text-align: center;
  }
`

const ImageContainer = styled.div<{ hasLink: boolean }>`
  cursor: ${({ hasLink }) => (hasLink ? 'pointer' : 'auto')};
  display: flex;
`

export default HealthIntro
